import RangeSlider from "../../../../common/RangeSlider";

const AdvancedPricingAccordion = ({ discount, onDiscountChange }) => {
  return (
    <section className="rounded-xl border border-gray-100 bg-slate-50/40 p-5">
      <div className="mb-4">
        <h3 className="text-sm font-bold text-gray-900">Discount</h3>
        <p className="text-sm text-gray-500 mt-0.5">
          Package discount applied to the listed price.
        </p>
      </div>

      <RangeSlider
        min={0}
        max={100}
        step={1}
        value={discount}
        onChange={onDiscountChange}
        label="Discount percentage"
      />
      <p className="text-xs text-gray-500 mt-1">
        Applied to the listed price if set.
      </p>
    </section>
  );
};

export default AdvancedPricingAccordion;
